// extracted by mini-css-extract-plugin
export default {"overlay":"Fr-z","bodyOpen":"Gr-z","content":"Hr-z","header":"Ir-z","close":"Jr-z","closeNoHeading":"Kr-z"};